export default "__VITE_ASSET__BcAFRKs3__"